export default "__VITE_ASSET__DqiW8cWP__"